//
// Used to avoid React re-render on non-primitive default props
//
const emptyFunction = () => (null);

export default emptyFunction;
